import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    optionalNumber,
    optionalString,
    optionalUuid,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createHorsesAddSchema = () =>
    z.object({
        id: requiredUuid(),
        name: requiredString(),
        foal_date: optionalString(),
        gender: optionalString(),
        shoe_size: optionalString(),
        shoe_type: optionalString(),
        breed: optionalString(),
        work_type: optionalString(),
        comments: optionalString(),
        stable_name: optionalString(),
        stable_address: optionalString(),
        stable_phone: optionalString(),
        microchip_no: optionalString(),
        sire_name: optionalString(),
        dam_name: optionalString(),
        stable_phone_prefix: optionalString(),
        hidden: optionalBoolean(),
        shoeing_cycle_weeks: optionalNumber(),
        shoeing_cycle_notify: optionalBoolean(),
        shoeing_cycle_badge: optionalBoolean(),
        location_id: optionalUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
    });

export const createHorsesUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createHorsesAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.horses,
    );

export const createHorsesDeleteSchema = () => createDeleteSchema();

export const createHorsesSchemas = () => ({
    add: createHorsesAddSchema(),
    update: createHorsesUpdateSchema(),
    delete: createHorsesDeleteSchema(),
});
